import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface LocationState {
  selectedLocationId: string;
  selectedLocationName: string;
  _hasHydrated: boolean;
  setSelectedLocationId: (id: string) => void;
  setSelectedLocation: (id: string, name: string) => void;
  clearSelectedLocation: () => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      selectedLocationId: '',
      selectedLocationName: '',
      _hasHydrated: false,
      setSelectedLocationId: (id) => set({ selectedLocationId: id }),
      setSelectedLocation: (id, name) => set({ selectedLocationId: id, selectedLocationName: name }),
      clearSelectedLocation: () => set({ selectedLocationId: '', selectedLocationName: '' }),
    }),
    {
      name: 'supernova-location',
      partialize: (state) => ({
        selectedLocationId: state.selectedLocationId,
        selectedLocationName: state.selectedLocationName,
      }),
    },
  ),
);

// Zustand 5 + synchronous localStorage: hydration completes inside create(),
// BEFORE the variable is assigned. Both onRehydrateStorage (self-reference
// undefined) and onFinishHydration (registered after hydration) miss the
// event. Fix: check hasHydrated() immediately + listen for future rehydrations.
if (useLocationStore.persist.hasHydrated()) {
  useLocationStore.setState({ _hasHydrated: true });
}
useLocationStore.persist.onFinishHydration(() => {
  useLocationStore.setState({ _hasHydrated: true });
});
